import {
  Tank,
  TankMeasures,
  Task,
  TaskChallenge,
  TaskEnvironmental,
  TaskFishReconciliation,
  TaskMortality,
  TaskPreChallenge,
  TaskVaccination,
} from "@/types/v2";
import { useTanksStore } from "@/stores/v2";
import { convertToDouble } from "@/utils/v2";



export function isVaccinationTask(task: Task): task is TaskVaccination {
  return task.objective.id === "vaccination";
}

export function isEnvironmentalTask(task: Task): task is TaskEnvironmental {
  return task.objective.id === "environmental";
}

export function isMortalityTask(task: Task): task is TaskMortality {
  return task.objective.id === "mortality";
}

export function isFishReconciliationTask(task: Task): task is TaskFishReconciliation {
  return task.objective.id === "fish_reconciliation";
}

export function isPreChallengeTask(task: Task): task is TaskPreChallenge {
  return task.objective.id === "pre_challenge";
}

export function isChallenge(task: Task): task is TaskChallenge {
  return task.objective.id === "challenge";
}

export function storeTanks(task: Task): void {
  if (isVaccinationTask(task) && task.details.tanks) {
    useTanksStore().setTanks(task.details.tanks);
  }
}

export const flattenDetails = (task: Task): unknown => {
  if (isEnvironmentalTask(task) && task.details?.tanks) {
    const convertedTanks: Tank[] = task.details.tanks.map((tank: any) => {
      if (tank.measures) {
        const convertedMeasures = {} as TankMeasures;

        for (const measureKey in tank.measures) {
          if (Object.prototype.hasOwnProperty.call(tank.measures, measureKey)) {
            const originalMeasure = tank.measures[measureKey];
            convertedMeasures[measureKey] = {
              value:
                convertToDouble(originalMeasure.value)?.toString() ||
                originalMeasure.value,
              unit: originalMeasure.unit,
            };
          }
        }

        return Object.assign({}, tank, { measures: convertedMeasures }) as Tank;
      }

      return tank as Tank;
    });

    task = { ...task, details: { ...task.details, tanks: convertedTanks } };
  }

  const { details, ...rest } = task;

  if (details) {
    // TODO: Enable this when the backend is ready to process snake case
    // const flattenedTask: Task = convertObjectKeysToSnake({
    //   ...rest,
    //   ...details,
    // });

    const flattenedTask: unknown = { ...rest, ...details };

    return flattenedTask;
  }

  return task;
};
